import DecisionScorePanel from "@Components/game/session-results/decision/decision-score-panel";
import FeedbackReplayLoadingState from "@Components/game/session-results/feedback/feedback-replay-loading-state";
import FeedbackReplayNotFoundState from "@Components/game/session-results/feedback/feedback-replay-not-found-state";
import ScenarioRetry from "@Components/game/session-results/feedback/scenario-retry";
import { ReplayActions, VideoContainer } from "@Components/game/session-results/feedback/styled-components";
import ReplayVisualization2D from "@Components/game/session-results/feedback/visualization/2d-replay-visualization";
import DecisionFilterMenu from "@Components/game/session-results/video/decision-filter-menu";
import VideoProgressBar from "@Components/game/session-results/video/video-progress-bar";
import { SessionFeedbackModel } from "@hooks/game/activity/session/use-session-feedback-model";
import { Stack } from "@mui/material";
import { useEffect, useRef } from "react";

interface IVideoStream {
  feedbackModel: SessionFeedbackModel;
}

const VideoStream = ({ feedbackModel }: IVideoStream) => {
  const { cognitiveResultId, replayData, isReplayLoading, areDecisionsLoading, isReplayNotFound } = feedbackModel.replay;
  const loadedReplayIdsRef = useRef<Set<number>>(new Set());

  useEffect(() => {
    if (replayData && cognitiveResultId) {
      loadedReplayIdsRef.current.add(cognitiveResultId);
    }
  }, [cognitiveResultId, replayData]);

  const shouldShowReplayLoader = !isReplayNotFound && (isReplayLoading || areDecisionsLoading);

  return (
    <Stack direction={{ xs: "column", lg: "row" }} gap={2} alignItems="stretch">
      <VideoContainer sx={{ flex: 1, minWidth: 0 }}>
        <ReplayVisualization2D feedbackModel={feedbackModel} />

        <ReplayActions>
          <DecisionFilterMenu feedbackModel={feedbackModel} />
          <ScenarioRetry variant="comparison" />
        </ReplayActions>

        <VideoProgressBar feedbackModel={feedbackModel} />

        {isReplayNotFound ? <FeedbackReplayNotFoundState /> : shouldShowReplayLoader && <FeedbackReplayLoadingState />}
      </VideoContainer>

      <DecisionScorePanel feedbackModel={feedbackModel} />
    </Stack>
  );
};

export default VideoStream;
